import { Button } from "@mui/material"
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import IconRemove from "src/assets/images/icon_remove.svg";

export const UnlistDepot = ({ selectedRow, handleUnlistDepotModalClose, unlistDepotClickHandler }) => {
    return <div>
        <div className="depot-form-header-style">
            <span className="allocate-mgnr-header-color me-2">UNLIST</span>
            <span className="allocate-mgnr-subheader-color">
                {selectedRow.name}
            </span>
        </div>
        <div style={{ paddingLeft: 100, paddingRight: 100 }}>
            <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                <span className="depotManagerName-style common-text-for-removeDepotManager">
                    {selectedRow.name}
                </span>
                <span className="removeDepotManager-text-removed common-text-for-removeDepotManager mb-2">
                    will be unlisted{" "}
                </span>
                <span className="long-text-style-unlist-depot mb-1">
                    This action cannot be undone.
                </span>
                <span className="long-text-style-unlist-depot mb-1">
                    This depot will still show up in old records/search results
                    where relevant.
                </span>
                <span className="long-text-style-unlist-depot mb-1">
                    The depot record can still be accessed through the above.
                </span>
                <span className="long-text-style-unlist-depot mb-1">
                    No further changescan be made to this record.
                </span>
                <span className="long-text-style-unlist-depot mb-1 last-text-for-unlist-depot">
                    The depot cannot be unlisted unless occupied area is 0 and
                    allocate managers are 0.
                </span>
            </div>

            <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                <span className="mb-3 confirm-msg-for-removeDepotManager">
                    Are you sure you want to proceed?
                </span>
                <div className="d-flex flex-row">
                    <Button
                        variant="outlined"
                        className="btn-bootstrap-submit-style"
                        startIcon={
                            <img
                                src={IconLeftArrow}
                                width={15}
                                height={15}
                                alt="new"
                            ></img>
                        }
                        onClick={handleUnlistDepotModalClose}
                        type="submit"
                    >
                        No, Go Back
                    </Button>

                    <Button
                        variant="outlined"
                        className="btn-bootstrap-submit-style ms-3"
                        style={{ color: "red", borderColor: "red" }}
                        onClick={unlistDepotClickHandler}
                        startIcon={
                            <img
                                src={IconRemove}
                                width={15}
                                height={15}
                                alt="new"
                            ></img>
                        }
                    >
                        Yes, Unlist Depot
                    </Button>
                </div>
            </div>
        </div>
    </div>
}